<template>
  <div>
    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Name"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-form-input
                id="name"
                v-model="name"
                v-restrict="regex"
                placeholder="PEEP Name"
                required
              />
            </b-form-group>

            <b-form-group
              label="building"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>


            <b-form-group
              label="floor"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 3"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="floor"
                placeholder="Select Floor"
                :options="floors"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
            
            <b-form-group
              label="Assistance Type"
              label-for="assistance_type"
              class="w-50"
              v-if="searchType.value === 4"
            >
              <b-form-input
                id="assistance_type"
                v-model="assistance_type"
                v-restrict="regex"
                placeholder="Assistance Type"
                required
              />
            </b-form-group>

            <b-form-group
              label="peep_type"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 5"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="peep_type"
                placeholder="Select PEEP Type"
                :options="peep_types"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
            
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="peeps"
        details-td-class="m-1 p-1"
        small
        v-if="hasPermission('read_peep')"
        :per-page="0"
      >
        <template #cell(name)="row">
          {{ row.item.user_data.name ? row.item.user_data.name : "" }}
        </template> 
        <template #cell(mobile_number)="row">
          {{ row.item.user_data.mobile_number ? row.item.user_data.mobile_number : "" }}
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';


export default {
  components: {
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Resident" },
        { key: "mobile_number", label: "Phone" },
        { key: "nominee_name", label: "Emergency Contact" },
        { key: "nominee_contact", label: "Contact" },
        { key: "assistance_type", label: "Assistance Type" },
        { key: "review_date", label: "Review Date" },
      ],
      
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      peeps: [],
      peep: null,
      searchTypes: [
        { value: 1, name: "Name" },
        { value: 2, name: "Building" },
        { value: 3, name: "Floor" },
        { value: 4, name: "Assistance Type" },
        { value: 5, name: "PEEP Type" },
      ],
      searchType: null,
      name: "",
      building: "",
      buildings: [],
      floor: "",
      floors: [],
      assistance_type: "",
      peep_type: "",
      peep_types: [
        { value: "Temporary", name: "Temporary" },
        { value: "Permanent", name: "Permanent" },
      ],

    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();

    const buildings = await this.getBuildingsDDL();
    this.buildings = buildings.data;

    const floors = await this.getFloorsDDL();
    this.floors = floors.data;
  },
  methods: {
    ...mapActions({
      getPeeps: "appData/getPeeps",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getFloorsDDL: "appData/getFloorsDDL",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.building = "";
            this.floor = "";
            this.assistance_type = "";
            this.peep_type = "";
            break;
          case 2:
            this.name = "";
            this.floor = "";
            this.assistance_type = "";
            this.peep_type = "";
            break;
          case 3:
            this.name = "";
            this.building = "";
            this.assistance_type = "";
            this.peep_type = "";
            break;
          case 4:
            this.name = "";
            this.building = "";
            this.floor = "";
            this.peep_type = "";
            break;
          case 5:
            this.name = "";
            this.building = "";
            this.floor = "";
            this.assistance_type = "";
            break;
        }
      } else {
        this.name = "";
        this.building = "";
        this.floor = "";
        this.assistance_type = "";
        this.peep_type = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getPeeps({
          pageNumber: this.currentPage,     
          name: this.name,
          building: this.building.id,
          floor: this.floor.id,
          assistance_type: this.assistance_type,
          peep_type: this.peep_type.value, 
        });
        this.peeps = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
